import { useMemo, useCallback, useRef } from 'react';
import styles from './AssignToDriver.module.css';
import { TextField, Button, Breadcrumbs, Typography } from '@mui/material';
import DataTable from 'react-data-table-component';
import { X, Plus, UserPlus, Edit } from 'react-feather';
import axios from 'axios';
import { TableLoader } from '../../components/LoaderC';
import Loader from '../../components/Loader';
import { authData } from "../../components/getAuth";
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import { Link } from '@mui/material';
import DriverAddForm from "../driver/addForm";
import AssignPopup from "./AssignToDriverPopup";
import withAdminAuth from "../../components/withAdminAuth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ComponentToPrintList } from './AssignToDriverPrint';
import { useReactToPrint } from 'react-to-print';
import { DateRangePicker } from 'rsuite';
import NotePopup from './NotePopup';
import PaymentPopup from '../bookings/PaymentPopup';
import { useState } from 'react';
import { useEffect } from 'react';

const DataTableWithExport = ({ columns, data, customStyles, onSelectedRowsChange, rowDisabledCriteria }) => {
  const componentRef = useRef();

  const Export = ({ onExport }) => <Button onClick={e => onExport(e.target.value)} className="TableAddBU" style={{ width: 'auto' }}>Export To CSV</Button>;

  const convertArrayOfObjectsToCSV = (array) => {
    let result;
    const columnDelimiter = ',';
    const lineDelimiter = '\n';
    const keys = ['booking_id', 'customer_name', 'recepient_name', 'delivery_address', 'order_status', 'contact_no', 'container'];

    result = '';
    keys.forEach(key => {
      if (key === 'booking_id') {
        result += 'Booking Id';
      } else if (key === 'customer_name') {
        result += 'Customer Name';
      } else if (key === 'recepient_name') {
        result += 'Recepient Name';
      } else if (key === 'delivery_address') {
        result += 'Delivery Address';
      } else if (key === 'order_status') {
        result += 'Order Status';
      } else if (key === 'contact_no') {
        result += 'Contact No';
      } else if (key === 'container') {
        result += 'Container';
      } else {
        result += key;
      }
      result += columnDelimiter;
    });
    result += lineDelimiter;

    array.forEach(item => {
      let ctr = 0;
      keys.forEach(key => {
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  const downloadCSV = useCallback(() => {
    let newArray = data.map(row => {
      return { 'booking_id': row?.reference_id, 'customer_name': row?.customer_name, 'recepient_name': row?.dropoff_details?.name, 'delivery_address': row?.dropoff_details?.address.replace(/,/g, ""), 'order_status': ((row?.payment_status === 1 || row?.payment_status === '1') ? 'Paid' : 'Unpaid'), 'contact_no': row?.dropoff_details?.phone, 'container': row?.container_name }
    });

    const link = document.createElement('a');
    let csv = convertArrayOfObjectsToCSV(newArray);
    if (csv == null) return;

    const filename = 'driver-list.csv';

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }
    link.setAttribute('href', encodeURI(csv));
    link.setAttribute('download', filename);
    link.click();
  }, [data]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const actionsMemo = useMemo(() => <><Export onExport={() => downloadCSV()} /><Button onClick={handlePrint} className="TableAddBU" style={{ width: 'auto' }}>Print Bookings</Button></>, [downloadCSV, handlePrint]);

  return <>
    <div style={{ display: "none" }}><ComponentToPrintList ref={componentRef} data={data} /></div>
    <DataTable
      className='DataTable'
      columns={columns}
      data={data}
      pagination
      selectableRows
      selectableRowDisabled={rowDisabledCriteria.bind(this)}
      onSelectedRowsChange={onSelectedRowsChange.bind(this)}
      customStyles={customStyles}
      actions={actionsMemo}
      noContextMenu={true}
    />
  </>
}

const customDataTableStyles = {
  head: {
    style: {
      zIndex: 0
    },
  },
  headCells: {
    style: {
      backgroundColor: '#1e1e2d',
      color: '#fff'
    },
  },
}

const BookingList = ({ history, match }) => {
  const auth = authData();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [datefilterData, setDatefilterData] = useState({ start_date: '', end_date: '' });
  const [selectedRows, setSelectedRows] = useState([]);
  const [assignModalShow, setAssignModalShow] = useState(false);
  const [addModalShow, setAddModalShow] = useState(false);
  const [noteModalShow, setNoteModalShow] = useState(false);
  const [paymentModalShow, setPaymentModalShow] = useState(false);
  const [editNote, setEditNote] = useState(null);
  const [currentItem, setCurrentItem] = useState(0);

  const columns = [{
    name: 'Booking Id',
    selector: row => row?.reference_id,
    sortable: true,
  }, {
    name: 'Customer Name',
    selector: row => row?.customer_name,
    sortable: true,
  }, {
    name: 'Recepient Name',
    selector: row => row?.dropoff_details?.name,
    sortable: true,
  }, {
    name: 'Delivery Address',
    selector: row => row?.dropoff_details?.address,
    sortable: true,
  }, {
    name: 'Delivery Notes',
    selector: row => ((row?.delivery_note && row?.delivery_note !== '') ? <><div style={{ marginRight: '25px' }}>{row?.delivery_note}</div><div style={{ position: 'absolute', right: '3px', top: '5px' }}><Button className={`${styles.StatusBU2}`} onClick={(e) => { setNoteModalShow(true); setCurrentItem(row?.id); setEditNote(row?.delivery_note); }}><Edit /></Button></div></> : <Button className={`${styles.StatusBU}`} onClick={(e) => { setNoteModalShow(true); setCurrentItem(row?.id); setEditNote(null); }}>Add Note</Button>),
    sortable: true,
  }, {
    name: 'Order Status',
    selector: tableProps => (<>
      {((tableProps?.payment_status === 1 || tableProps?.payment_status === '1') ? <Button className={`${styles.StatusBU} ${styles.DisaBU}`}>Paid</Button> : <Button className={`${styles.StatusBU}`} onClick={(e) => { setPaymentModalShow(true); setCurrentItem(tableProps?.id); }}>Unpaid</Button>)}
    </>),
    sortable: true,
  }, {
    name: 'Contact No',
    selector: row => row?.dropoff_details?.phone,
    sortable: true,
  }, {
    name: 'Container',
    selector: row => row?.container_name,
    sortable: true,
  }
  ];

  useEffect(() => {
    const fetchUsers = () => {
      axios(process.env.REACT_APP_API_URL + 'v1/delivery/assign-bookings', {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then(response => {
        setContentLoading(false);
        if (response.data.status === 'SUCCESS') {
          setAllData(response.data.data);
        }
      }).catch(error => {
        setContentLoading(false);
      });
    }

    fetchUsers();
  }, [auth?.api_token]);

  useEffect(() => {
    let filteredData = allData;

    if (filterText !== '') {
      let inputVal = filterText;
      inputVal = inputVal.toLowerCase();
      filteredData = filteredData.filter((item) => {
        return item?.reference_id.toLowerCase().includes(inputVal) || item?.customer_name.toLowerCase().includes(inputVal) || item?.dropoff_details?.name.toLowerCase().includes(inputVal) || item?.dropoff_details?.address.toLowerCase().includes(inputVal) || item?.dropoff_details?.phone.toLowerCase().includes(inputVal) || item?.container_name.toLowerCase().includes(inputVal);
      });
    }

    if (datefilterData?.start_date !== '' && datefilterData?.end_date !== '') {
      filteredData = filteredData.filter((item) => moment(item.pickup_date).isBetween(moment(datefilterData?.start_date), moment(datefilterData?.end_date), 'days', '[]'));
    }

    setData(filteredData);
  }, [allData, filterText, datefilterData]);

  const rowDisabledCriteria = (e) => {
    return parseInt(e?.payment_status) !== 1;
  }

  const handleChange = ({ selectedRows }) => {
    let selectedRowTemp = selectedRows.map(item => {
      return item.id;
    });
    setSelectedRows(selectedRowTemp);
  }

  const assignDriver = (message) => {
    toast.success(message, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "light",
    });

    axios(process.env.REACT_APP_API_URL + 'v1/delivery/assign-bookings', {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        setAllData(response.data.data);
      }
    }).catch(error => { })
  }

  const onSubmitAddForm = () => {
    return null;
  }

  const noteItemAdd = (message, item) => {
    toast.success(message);

    setAllData(prev => {
      return prev.map(i => {
        if (i.id === item?.id)
          return { ...i, delivery_note: item?.delivery_note }
        return i;
      });
    })
  }

  const paymentItem = (message, id) => {
    toast.success(message);

    setAllData(prev => {
      return prev.map(i => {
        if (i.id === id)
          return { ...i, payment_status: 1 }
        return i;
      });
    })
  }

  return (<>
    {loading && <Loader />}
    {contentLoading && <div className="LoaderCard"><div className="Loader TableLoader"><TableLoader /></div></div>}
    {!contentLoading && <div className={`${styles.MainDiv}`}>
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>Assign Booking For Delivery</p>
        <Breadcrumbs aria-label="breadcrumb" className='breadcrumb'>
          <Typography color="text.primary">Ghana Delvery</Typography>
          <Typography color="text.primary">Assign Driver</Typography>
        </Breadcrumbs>
      </div>

      <div className={`${styles.MainCard}`}>
        <div className='TableFilterHead'>
          <div className="DataTableSearch">
            <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={filterText} onChange={(e) => setFilterText(e.target.value)} autoComplete='off' />
            {filterText !== '' && <Button type="button" className="CloseBU" onClick={(e) => setFilterText('')}><X /></Button>}
          </div>
          <div style={{ width: '320px', marginLeft: '16px' }}>
            <DateRangePicker
              showOneCalendar
              format="dd/MM/yyyy"
              placeholder="Search by date"
              ranges={[]}
              onChange={(e) => {
                if (e) {
                  setDatefilterData({ start_date: moment(e[0]).format('YYYY-MM-DD'), end_date: moment(e[1]).format('YYYY-MM-DD') });
                } else {
                  setDatefilterData({ start_date: '', end_date: '' });
                }
              }}
            />
          </div>
          <div className='TableFilterBUSec'>
            <Button className="TableAddBU" disabled={selectedRows.length === 0} onClick={(e) => setAssignModalShow(true)}><UserPlus /> Assign</Button>
            <Link className="TableAddBU" onClick={(e) => setAddModalShow(true)}><Plus /> Driver</Link>
          </div>
        </div>

        <div className='TableContent'>
          <DataTableWithExport columns={columns} data={data} rowDisabledCriteria={rowDisabledCriteria.bind(this)} onSelectedRowsChange={handleChange.bind(this)} customStyles={customDataTableStyles} />
        </div>
      </div>
    </div>}

    <Modal show={addModalShow} onHide={(e) => setAddModalShow(false)} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>Add Driver</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DriverAddForm onSubmit={onSubmitAddForm.bind(this)} isAddMode={true} id={0} setModalShow={setAddModalShow.bind(this)} setCurrentItem={setCurrentItem.bind(this)} setLoading={setLoading.bind(this)} />
      </Modal.Body>
    </Modal>

    <Modal show={assignModalShow} onHide={(e) => setAssignModalShow(false)} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>Assign Booking Details To Driver</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AssignPopup onSubmit={assignDriver.bind(this)} setModalShow={setAssignModalShow.bind(this)} setLoading={setLoading.bind(this)} selectedRows={selectedRows} />
      </Modal.Body>
    </Modal>

    <Modal show={noteModalShow} onHide={(e) => setNoteModalShow(false)} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>{editNote ? 'Edit Note' : 'Add Note'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <NotePopup setModalShow={setNoteModalShow.bind(this)} noteItem={noteItemAdd.bind(this)} bookingId={currentItem} editNote={editNote} setLoading={setLoading.bind(this)} />
      </Modal.Body>
    </Modal>

    <Modal show={paymentModalShow} onHide={(e) => setPaymentModalShow(false)} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>Payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PaymentPopup setModalShow={setPaymentModalShow.bind(this)} paymentItem={paymentItem.bind(this)} bookingId={currentItem} setCurrentItem={setCurrentItem.bind(this)} setLoading={setLoading.bind(this)} />
      </Modal.Body>
    </Modal>
  </>);
}

export default withAdminAuth(BookingList);